import MadeByOlaBanner from "../components/BottomBanner/MadeByOlaBanner";
import Button from "../components/general/Button"
import { useNavigate } from "react-router-dom";

function PageNotFound() {
  const navigate = useNavigate();

  return (
    <div className="px-3 md:px-10 w-full min-h-screen flex flex-col justify-center items-center">
       <h1 className="text-3xl md:text-5xl font-black text-black font-boska text-center">
        Page Not Found!
       </h1>
       <Button text="Go To Home Page" onClick={() => navigate("/")}/>
       <div className="flex justify-center pt-2">
       <MadeByOlaBanner />
       </div>
    </div>
  )
}

export default PageNotFound